import React from "react";
import {CodeComponent} from "../code/CodeComponent";

export function AccordionHeaderTextComponent({title, description}) {
    return (
        <span className={"accordionHeaderText"}>
            <strong>{title}: </strong>{description && description}
        </span>
    )
}

export function AccordionHeaderTextTimeComplexityComponent({title, timeComplexity, description}) {
    return (
        <span className={"accordionHeaderText"}>
            <strong>{title}: </strong>
            <CodeComponent>{timeComplexity}</CodeComponent> {description && description}
        </span>
    )
}

export function AccordionHeaderTextExtraTimeComplexity({
                                                           title,
                                                           timeComplexity,
                                                           extraTimeComplexity,
                                                           isTitleEmphasized
                                                       }) {
    return (
        <span className={"accordionHeaderText"}>
            <strong className={isTitleEmphasized ? "accordionHeaderTextEmphasized" : ""}>{title}: </strong>
            <CodeComponent>{timeComplexity}</CodeComponent>, but also kind of <CodeComponent>{extraTimeComplexity}</CodeComponent>
        </span>
    )
}

export function AccordionHeaderTextEmphasized({title, description, timeComplexity}) {
    return (
        <span className={"accordionHeaderText"}>
            <strong className="accordionHeaderTextEmphasized">{title}: </strong>
            {description} <CodeComponent>{timeComplexity}</CodeComponent>
        </span>
    )
}
